import { render, staticRenderFns } from "./PlayerChatPopup.vue?vue&type=template&id=337c20b3&scoped=true"
import script from "./PlayerChatPopup.vue?vue&type=script&lang=js"
export * from "./PlayerChatPopup.vue?vue&type=script&lang=js"
import style0 from "./PlayerChatPopup.vue?vue&type=style&index=0&id=337c20b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337c20b3",
  null
  
)

export default component.exports